/**
 * Web and desktop have no address book: the Save Order sheet hides the Phone
 * contacts section. Same API as the native file.
 */
import type { PickerContact } from '../utils/customerPicker';

export type ContactsPermission =
  | 'granted'
  | 'undetermined'
  | 'denied'
  | 'blocked'
  | 'unavailable';

export const PHONE_CONTACTS_SUPPORTED = false;

export const mapIosPermission = (_value: string): ContactsPermission =>
  'unavailable';

export const mapAndroidRequestResult = (_value: string): ContactsPermission =>
  'unavailable';

export const checkContactsPermission = async (): Promise<ContactsPermission> =>
  'unavailable';

export const requestContactsPermission =
  async (): Promise<ContactsPermission> => 'unavailable';

export const loadPhoneContacts = async (): Promise<PickerContact[]> => [];
